import i18n from '../../locales/index'
// import axios from 'axios'
import { randomString } from '@/libs/util'
import OSS from 'ali-oss'
import config from '@/config'
const rootConfig = require('../../../config')

export default {
  methods: {
    async uploadHttp ({ file }) {
      const random_name = randomString(32) + '.' + file.name.split('.').pop()
      // const { data } = await axios.get('/sts')
      const { ACCESS_KEY, SECRET_KEY, image_bucket, image_region } = rootConfig['alioss']

      const conf = {
        region: image_region,
        accessKeyId: ACCESS_KEY,
        accessKeySecret: SECRET_KEY,
        // stsToken: data.security_token,
        bucket: image_bucket
      }
      const ossClient = new OSS(conf)

      ossClient.put(random_name, file, {
        ContentType: 'image/*'
      }).then(({ res, url, name }) => {
        if (res && res.status === 200) {
          // console.info('upload', res, url, name)
          // this.url = url
          const imgUrl = `https://fresh-picture.chengbao68.com/${name}`
          console.log(imgUrl)
          this.$emit('uploadedUrl', imgUrl);
          if (this.addUrl) {
            this.addUrl(imgUrl);
          }
        }
      }).catch((err) => {
        console.log('阿里云OSS上传图片失败回调', err)
      })
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png' || 'image/gif'
      const limit = this.limit || 10
      const isLt2M = file.size / 1024 / 1024 <= limit

      if (!isJPG) {
        this.$message.error(i18n.t('components_uploader_aliyun_mixin_37'))
      }
      if (!isLt2M) {
        this.$message.error(i18n.t('components_uploader_aliyun_mixin_38', [limit]))
      }
      return isJPG && isLt2M
    }
  }
}
